<template>
    <div class="row" style="flex-wrap: nowrap !important;" v-if="!pipeline.loading">
        <div class="col-2 kanban" v-for="(item,index) in testItems">
            <h3 class="kanban-title mb-1" style="text-transform: capitalize;">{{item.opportunity.opportunity_name}}</h3>
                <!-- @change="log($event,item.opportunity.opportunity_id)" -->
            <draggable
                class="list-group"
                :list="item.opportunity.data"
                :component-data="{
                    tag: 'ul',
                    type: 'transition-group',
                    name: !drag ? 'flip-list' : null
                }"
                v-bind="dragOptions"
                group="people"
                @change="onChange"
                @add="onAdd($event,item.opportunity.opportunity_id,item.opportunity.opportunity_name)"
                itemKey="name"
            >
                <template #item="{ element, index }">
                    <div class="list-group-item kanban-items"  v-if="element.client" style="cursor: all-scroll;position:relative;cursor: pointer;">
                        <div class="dropdown " style="cursor: pointer;position: absolute;right: 0px;top: 14px;">
                            <vue-feather class="mr-50 dropdown-toggle" type="more-vertical"  id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></vue-feather>
                            <div class="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuLink" style="top: -16px; !important">
                                <a class="dropdown-item delete-task" href="javascript:void(0)" v-on:click="DeletePipeline(element.client.id)">Remove Client</a>
                            </div>
                        </div>

                        <div v-on:click="toggleModel(item.opportunity.opportunity_id,element.client_id,element.client)" style="cursor: all-scroll;">
                            <div class="d-flex justify-content-between flex-wrap align-items-center pb-1">
                                <div class="item-badges">
                                    <div class="badge rounded-pill me-50 mr-75 badge-light-warning" style="text-transform: capitalize;" v-if="element.status.toLowerCase() == pipeline.IN_REVIEW"> {{element.status}}</div>
                                    <div class="badge rounded-pill me-50 mr-75 badge-light-info" style="text-transform: capitalize;" v-else-if="element.status.toLowerCase() == pipeline.IN_PROGRESS"> {{element.status}}</div>
                                    <div class="badge rounded-pill me-50 mr-75 badge-light-success" style="text-transform: capitalize;" v-else-if="element.status.toLowerCase() == pipeline.DONE"> {{element.status}} </div>
                                    <div class="badge rounded-pill me-50 mr-75 badge-light-info" style="text-transform: capitalize;" v-else> {{element.status}}</div>
                                </div>

                            </div>

                            <p class="kanban-text" style="font-size:15px;text-transform: capitalize;font-weight:bolder;margin-bottom:0px;"> {{element.client.full_name}} </p>
                            <span class="kanban-text" style="text-transform: capitalize;font-size: 15px;" v-if="element.due_date != null">
                                <span style="font-weight:bolder;" >Due: </span> {{DateConverter(element.due_date)}}
                            </span>

                            <div class="d-flex justify-content-between align-items-center flex-wrap pt-1">
                                <div class="d-flex">
                                    <span class="d-flex align-items-center ms-1">
                                        <vue-feather class="mr-50" type="message-square" style="width:16px;"></vue-feather>
                                        <span> {{element.notes_count}} </span>
                                    </span>
                                    <span class="d-flex align-items-center ms-1" style="padding-left: 7px;">
                                        <vue-feather type="file-text" class="mr-50 " style="width:16px;"></vue-feather>
                                        <span> {{element.client.dispute_activities_count}} </span>
                                    </span>

                                </div>
                                <div class="avatar" v-if="element.client.assigned_user != null">
                                    <div class="avatar-content avatar-xl bg-light-primary" height="38" width="38" style="color: white !important;background: #4b9a5e !important;">
                                        <span class="avatar-content" v-if="element.client.assigned_to">
                                            {{abbreviateName(element.client.assigned_user.full_name)}}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </template>
                <!-- crear -->
                <template #footer v-if="item.opportunity.opportunity_name.toLowerCase() == 'lead' && !showAddClientField">
                    <button type="button" class="btn btn-success" @click="addClient" v-on:click="showAddClient()">+ Add To Pipeline</button>
                </template>
                <template #footer v-if="item.opportunity.opportunity_name.toLowerCase() == 'lead' && showAddClientField">
                    <div class="form-group">
                        <label class="form-label" for="basic-icon-default-fullname">Client Name </label>
                        <select2 v-model="selectedClient" :options="clients" ></select2>
                    </div>
                    <div class="form-group">
                        <a class="btn btn-primary waves-effect waves-float waves-light " href="#" v-on:click.prevent="addClientToPipeline(item.opportunity.opportunity_id, selectedClient,'add',null)">Save To Pipeline</a>
                        <a class="btn btn-outline-primary me-3 waves-effect waves-light ml-2" href="#" v-on:click.prevent="showAddClient()">Cancel</a>
                    </div>
                </template>
            </draggable>
        </div>
        <div v-for="(item,index) in testItems">
            <rawDisplayer class="col-3" :value="item.opportunity"/>
        </div>
    </div>
    <div v-else>
        <loader/>
    </div>

    <client-pipeline-modal @refresh="showClientToPipeline" ></client-pipeline-modal>
  </template>
  <script>
  import draggable from "vuedraggable";
  import {ref} from "vue";
  import Select2 from 'vue3-select2-component'
  import 'vue-select/dist/vue-select.css';
  import ClientPipelineModal from "./modal/ClientPipelineModal.vue"
  import {usePipelineStore} from '../../../../stores/PipelineStore.js';
  import {useLocalizationStore} from '../../../../stores/LocalizationStore.js';
  import Loader from '../../../report/Loader.vue'
  import moment from 'moment'
  export default {
    name: "two-lists",
    display: "Two Lists",
    order: 1,
    components: {
        Select2,
        draggable,
        ClientPipelineModal,
        'loader':Loader
    },
    setup(){
        const pipeline = usePipelineStore(),
        localizationStore = useLocalizationStore(),
        client_id = ref(),
        add_client = ref(),
        selectedClient = ref(),
        clients = ref([]),
        showAddClientField=ref(false),
        opportunity_id = ref(),
        pipeline_id = ref(),
        loading= ref(true);
        return{
            pipeline,
            localizationStore,
            client_id,
            add_client,
            selectedClient,
            clients,
            showAddClientField,
            opportunity_id,
            pipeline_id,
            loading
        }
    },

    data() {
      return {
        testItems:{}
      };
    },
    watch: {
        async 'pipeline.opportunities' (value) {
            let array = [];
            value.forEach(element => {
                array.push(element);
            });
            this.testItems = value;
        },
        async 'pipeline.loading' (value) {
            this.loading = value;
        },
    },
    computed: {
        dragOptions() {
            return {
                animation: 200,
                group: "description",
                disabled: false,
                ghostClass: "ghost"
            };
        }
    },
    mounted() {
        this.showClientToPipeline()
        this.pipeline.fetchOpportunities();
    },
    methods: {
        DateConverter(date){
            return moment(date).format('ll');
        },
        onAdd(event,opportunity,opportunity_name) {
            this.opportunity_id = opportunity;
            this.addClientToPipeline(opportunity,this.client_id,'drag',opportunity_name);
        },
        onChange(event){
            if (event.added != undefined) {
                this.client_id = event.added.element.client_id
            }
        },
        toggleModel(client_id,pipeline_id,client){
            if(client_id !== null && pipeline_id !== null){
                this.pipeline.pipeline_id = client_id;
                this.pipeline.client_id = pipeline_id;
                this.pipeline.client_details = client;
                this.pipeline_id = pipeline_id;
            }
            this.pipeline.toggleActiveModel = !this.pipeline.toggleActiveModel
        },
        showClientToPipeline(){
            const $this=this;
            const route = this.$router.resolve(
                {
                    name:"pipeline.show.client"
                }
            );
            axios.get(route.href).then(({data})=>{
                if(data.error != true){
                    this.clients = data.data.map(client => ({
                        id: client.id,
                        text: client.full_name
                    }));
                    return;
                }else{
                    toastr.error(data.message, 'Add Client Success Error!');
                    return;
                }
            }).catch(function(error) {
                toastr.error(error.response.data.response_msg, 'Add Client Success Error!');
            });
        },
        addClientToPipeline(opportunity_id,client_id,type,opportunity_name){
            const $this=this;
            const route = this.$router.resolve(
                {
                    name:"pipeline.add.client"
                }
            );
            if(opportunity_id == null || client_id == null){
                return toastr.error('Please select a client to add or update.', 'Add Contact Error!');
            }
            const params = {
                client: Number(client_id),
                opportunity: Number(opportunity_id)
            }
            axios.post(route.href,params).then(({data})=>{
                if(data.error != true){
                    this.pipeline.fetchOpportunities();
                    this.showClientToPipeline();
                    if(type == 'add'){
                        this.showAddClient();
                        this.selectedClient = null;
                        toastr.success('Contact added to pipeline successfully', 'Add Contact Success Error!');
                        return true;
                    }
                    // toastr.success(`Contact Moved To ${opportunity_name}`, 'Update Contact Success Error!');
                    return true;
                }else{
                    toastr.error(data.message, 'Add Contact Success Error!');
                    return false;
                }
            }).catch(function(error) {
                toastr.error(error.response.data.response_msg, 'Add Contact Success Error!');
                return false;
            });
        },
        DeletePipeline(id){
            const $this = this;
            Swal.fire({
                title: $this.localizationStore.translate('are.you.sure'),
                text: 'You will not be able to revert this process.',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, Remove Client',
                customClass: {
                    confirmButton: 'btn btn-primary',
                    cancelButton: 'btn btn-outline-danger ml-1'
                },
                buttonsStyling: false
            }).then(function (result) {
                if (result.value) {
                    const route = $this.$router.resolve(
                        {
                            name:"pipeline.destroy.client",
                            params:{
                                client: id
                            }
                        }
                    );
                    axios.delete(route.href).then(({data})=>{
                        if(data.error != true){
                            toastr.success(data.message, 'Success!');
                            $this.pipeline.fetchOpportunities()
                            $this.$emit("refresh-client");
                            return true;
                        }else{
                            toastr.error(data.message, 'Error!');
                            return false;
                        }
                    }).catch(function(error) {
                        toastr.error(error.response.data.response_msg, 'Error!');
                        return false;
                    });
                }
            });
        },
        showAddClient(){
            this.showAddClientField = !this.showAddClientField;
        },
        abbreviateName(fullname){
            return fullname.replace(/\b(\w)\w+/g, '$1.').replace(/\s/g, '').replace(/\.$/, '').toUpperCase();
        }
    }
  };
  </script>
  <style>
    .kanban{
        min-height: 1rem;
        min-width: 16.25rem;
    }
    .kanban .kanban-items{
        border-radius: 0.375rem;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-direction: column;
        flex-direction: column;
        margin-bottom: 1rem;
        padding: 1rem;
        position: relative;
    }
    .avatar-img{
        height:20px;
        width: 20px;
    }
    .kanban-tasks-item-dropdown {
        cursor: pointer;
        display: none;
        position: absolute;
        right: 0.75rem;
    }
    .kanban-title{
        font-size: 1.125rem;
        font-weight: 600;
        max-width: 13rem;
        overflow: hidden;
        white-space: nowrap;
        padding-left: 18px;
    }
    .active_round{
        z-index: 40;
        background: green !important;
        color: white;
        transform: scale(1.1);
    }
  </style>
